import { serviceRouteConstants } from "@/Constants/routingConstants";

import { get, post, postFormData } from ".";

export const _fetchChatUsers = async (data) => {
  let postData = {
    page: data.currentPage,
    search: data.search,
    candidateId: data.candidateId,
    userType: data.userType || "client",
    conversationKey: data.conversationKey || "",
    requestFor: data?.requestFor || "",
  };

  const request = {
    endPoint: serviceRouteConstants.chatUsers,
    data: postData,
  };
  return await post(request);
};

export const _fetchChatMessages = async (data) => {
  // let postData = {
  //   candidate_id: data.candidateId,
  //   userType: data.userType,
  //   page: data.currentPage,
  // };

  const request = {
    endPoint: serviceRouteConstants.chatHistory,
    data: data,
  };
  return await post(request);
};

export const _uploadChatDocument = async (data) => {
  let formData = new FormData();
  formData.append("send_file", data.chat_attachment);

  return postFormData(serviceRouteConstants.sendChatAttanchment, formData);
};

export const _markChatAsRead = async (data) => {
  let postData = {
    sender_id: data.senderId,
    receiver_id: data.receiverId,
    send_from: data.sendFrom,
    send_to: data.sendTo,
  };

  const request = {
    endPoint: serviceRouteConstants.markChatAsRead,
    data: postData,
  };
  return await post(request);
};

export const _sendNotificationToCandidate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.sendNotificationToCandidate,
    data: data,
  };
  return await post(request);
};

export const _getTotalUnreadCount = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.getTotalUnreadCount,
    data: data,
  };
  return await get(request);
};

export const _saveChatTemplate = async (data) => {
  let postData = {
    template_name: data.template_name,
    template_message: data.template_message,
    is_update: data.is_update || 0,
    template_id: data.template_id,
  };

  const request = {
    endPoint: serviceRouteConstants.saveChatTemplate,
    data: postData,
  };
  return await post(request);
};

export const _getChatTemplate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.getChatTemplate,
    data: data,
  };
  return await get(request);
};

export const _storeOfflineMessage = async (data) => {
  let postData = {
    user_type: data.user_type,
    department_id: data.department_id,
    receiver_id: data.receiver_id,
    message: data.message,
    original_filename: data.original_filename,
    send_from: data.send_from,
    send_to: data.send_to,
    message_id: data.message_id,
    message_type: data.message_type,
  };

  const request = {
    endPoint: serviceRouteConstants.offlineMessage,
    data: postData,
  };
  return await post(request);
};

export const _createChat = async (data) => {
  let formData = new FormData();
  formData.append("group_name", data.group_name);
  formData.append("group_icon", data.group_icon);
  formData.append("group_description", data.group_description);
  formData.append("group_status", data.group_status);
  formData.append("group_type", data.group_type);
  formData.append("candidate_ids", data.candidate_ids);
  if (data?.isSelectedAll) {
    formData.append("isSelectedAll", data.isSelectedAll);
    formData.append("search", data.search);
  }
  formData.append("ignoreIds", data.ignoreIds);
  return postFormData(serviceRouteConstants.createBroadcast, formData);
};

//

export const _fetchBroadCastChatGrpDetails = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.getBroadcastChatGrpDetails,
    data: data,
  };
  return await post(request);
};

export const _addCandidatesFromBroadCast = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.addCandidateToBroadCastGroup,
    data: data,
  };
  return await post(request);
};

export const _removeCandidatesfromBroadCast = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.deleteCandidateToBroadCastGroup,
    data: data,
  };
  return await post(request);
};

// deleteBroadCastGroup

export const _deleteBroadCastGroup = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.deleteBroadCastGroup,
    data: data,
  };
  return await post(request);
};
